
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'

import { FlxButtonModule } from '@flowx/angular-ui-toolkit'
import {
  ApplicationResourceStatus,
  ApplicationType,
} from '@flowx/designer/shared/entities/application.entity'
import { BranchNameComponent } from '@flowx/designer/shared/versioning/branch-name/branch-name.component'
import { BranchStateIconComponent } from '@flowx/designer/shared/versioning/branch-state-icon/branch-state-icon.component'
import { FlxBranchStateComponent } from '@flowx/designer/shared/versioning/branch-state/branch-state.component'

@Component({
  selector: 'flx-reusable-template-info',
  imports: [
    FlxButtonModule,
    FlxBranchStateComponent,
    BranchNameComponent,
    BranchStateIconComponent
],
  template: `
    <div class="flex flex-col gap-2 rounded-lg">
      <button
        (click)="goToReusableTemplateClicked.emit()"
        class="text-blue-500 font-semibold text-base inline-flex items-center justify-start gap-x-2 p-0"
        flxButton
        variant="text"
      >
        <i class="ph ph-arrow-circle-up-right"></i>
        <ng-content />
      </button>
      <div class="flex flex-row gap-2 items-center h-[30px]">
        <span class="text-neutral-900 font-semibold">{{ reusableInfo().type }}:</span>
        <span class="text-neutral-600">
          {{ reusableInfo().appName }}
        </span>
      </div>
      <div class="flex flex-row gap-2 items-center h-[30px]">
        <span class="text-neutral-900 font-semibold">Branch:</span>
        <div class="flex flex-row items-center gap-x-2">
          <flx-branch-state-icon
            [status]="reusableInfo().status"
            [branchName]="reusableInfo().branchName"
          />
          <flx-branch-name [branchName]="reusableInfo().branchName" />
          <flx-branch-state [status]="reusableInfo().status" />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-center h-[30px]">
        <span class="text-neutral-900 font-semibold">{{ reusableInfo().type }} version id:</span>
        <span class="text-neutral-600 text-xs">
          {{ reusableInfo().appVersionId }}
        </span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxReusableTemplateInfoComponent {
  reusableInfo = input<{
    appName: string
    appVersionId: string
    branchName: string
    status: ApplicationResourceStatus
    type: ApplicationType
  }>()
  goToReusableTemplateClicked = output()
}
